import Icon from 'front-onceforall-core/dist/components/Icon';
import {Translate} from 'react-redux-i18n';

function NotDepositorMessageView() {
  return (
    <div className="box info flex-container space-between">
      <div className="pr-5">
        <h3>
          <Translate value="subcontractor.reinvite.title"/>
        </h3>
        <Translate value="subcontractor.reinvite.text"/>
      </div>
      <div
        style={{
          marginRight: 70,
          transform: 'rotate(90deg)'
        }}
      >
        <Icon
          icon="go-back"
          size={30}
        />
      </div>
    </div>
  );
}

export default NotDepositorMessageView;
